import { render, staticRenderFns } from "./RoleManagement.vue?vue&type=template&id=12ddc9ba&"
import script from "./RoleManagement.vue?vue&type=script&lang=js&"
export * from "./RoleManagement.vue?vue&type=script&lang=js&"
import style0 from "./RoleManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports